import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import { TEXT } from '../../theme/tokens'

/** Confirmation gate for destructive actions (e.g. removing the AI key). */
const ConfirmDialog = ({
    open,
    title,
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    destructive = false,
    onConfirm,
    onCancel,
}) => (
    <Dialog open={open} onClose={onCancel} aria-labelledby="confirm-title">
        <DialogTitle id="confirm-title" variant="h4" component="h2">
            {title}
        </DialogTitle>
        <DialogContent>
            <DialogContentText variant="body2" sx={{ color: TEXT.secondary }}>
                {message}
            </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button variant="outlined" onClick={onCancel}>
                {cancelLabel}
            </Button>
            <Button
                variant="contained"
                color={destructive ? 'error' : 'primary'}
                onClick={onConfirm}
            >
                {confirmLabel}
            </Button>
        </DialogActions>
    </Dialog>
)

ConfirmDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    confirmLabel: PropTypes.string,
    // The dismiss button's label, when "Cancel" would read as the action
    // itself (cancelling a scheduled send).
    cancelLabel: PropTypes.string,
    destructive: PropTypes.bool,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
}

export default ConfirmDialog
